import { ProjectArea, ProjectStorey, ProjectZone } from "@facade/contracts";

import { createContext } from "react";

export type DeleteLocationTarget =
  | {
      type: "ZONE";
      item: ProjectZone;
      childrenCount: number;
    }
  | {
      type: "STOREY";
      item: ProjectStorey;
      childrenCount: number;
    }
  | {
      type: "AREA";
      item: ProjectArea;
      childrenCount: 0;
    };

export type ProjectLocationsTreeContextValue = {
  zones: ProjectZone[];
  storeysByZoneId: Record<string, ProjectStorey[]>;
  areasByStoreyId: Record<string, ProjectArea[]>;
  deleteTarget: DeleteLocationTarget | null;
  duplicateTarget: ProjectZone | null;
  selectedStoreyIds: string[];

  createZone: () => Promise<void>;
  createStorey: (
    zone: ProjectZone,
    placement: "ABOVE" | "UNDER",
  ) => Promise<ProjectStorey | undefined>;
  createArea: (storey: ProjectStorey) => Promise<void>;
  moveStorey: (
    storey: ProjectStorey,
    direction: "UP" | "DOWN",
  ) => Promise<void>;
  moveStoreyToZone: (
    targetZoneId: string,
    storeyIds: string[],
  ) => Promise<void>;

  renameZone: (zone: ProjectZone, name: string) => Promise<void>;
  renameStorey: (storey: ProjectStorey, name: string) => Promise<void>;
  renameArea: (storey: ProjectArea, name: string) => Promise<void>;

  duplicateZone: (zone: ProjectZone) => Promise<void>;
  updateDuplicateTarget: (zone: ProjectZone | null) => void;
  duplicateStorey: (storey: ProjectStorey) => void;

  requestRemoveZone: (zone: ProjectZone) => void;
  requestRemoveStorey: (storey: ProjectStorey) => void;
  requestRemoveArea: (area: ProjectArea) => void;
  closeDeleteDialog: () => void;
  confirmDelete: () => Promise<void>;
  updateStoreyNumber: (storey: ProjectStorey, value: number) => void;

  isStoreySelected: (storeyId: string) => boolean;
  setStoreySelected: (storeyId: string, selected: boolean) => void;
  clearSelectedStoreys: () => void;

  isCreatingZone: boolean;
  isCreatingStorey: boolean;
  isCreatingArea: boolean;
  isMovingStorey: boolean;
  isDeletingLocation: boolean;
  isUpdatingLocation: boolean;
};

export const ProjectLocationsTreeContext =
  createContext<ProjectLocationsTreeContextValue>(
    {} as ProjectLocationsTreeContextValue,
  );
